import React, { Fragment } from 'react';
import { Row } from 'react-bootstrap';
import ToolButtons from '../Common/ToolButtons/ToolButtons'
import './InsuranceTools.scss';

export default function Tools() {
    return (
        <Fragment>
            <Row className='peoduct-head'>
                <h4 className='font-weight-bold'>Insurance Tools</h4>
            </Row>
            <Row>
                <ToolButtons isHomePage />
            </Row>
        </Fragment>
      )
  }


// WEBPACK FOOTER //
// ./src/components/Home/Tools.js